<template>
  <section id="about-us" class="container section text_page">
    <div class="columns is-centered">
      <div class="column is-half-fullhd">
        <h1 class="title">{{ t("about.title") }}</h1>

        <p>{{ t("about.text1") }}</p>

        <p>
          <span class="list-title">{{ t("about.list-title") }}</span>
        </p>
        <ul>
          <li v-for="(item, index) in aboutList" :key="index">
            <b>{{ item.title }}</b>
            {{ item.text }}
          </li>
        </ul>

        <p>{{ t("about.text2") }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t, messages, locale } = useI18n();

const aboutList = computed(
  () => messages.value[locale.value]?.about?.list || [],
);
</script>

<style lang="scss" scoped>
.text_page {
  .list-title {
    font-weight: bold;
    margin-bottom: 0.5em;
    display: block;
  }

  ul {
    margin-left: 1.2em;
    list-style-type: disc;
  }

  li {
    margin-bottom: 0.4em;
  }
}
</style>
